/* FM Geo M2 reviews — prev/next paging for the scroll-snap carousel.
   Swiping, trackpad and keyboard scrolling are native; this only drives the
   buttons and keeps their disabled state in sync. No dependency. */
(function () {
  function init(root) {
    if (!root || root.dataset.fmRevInit === '1') return;
    root.dataset.fmRevInit = '1';

    var track = root.querySelector('[data-fm-rev-track]');
    if (!track) return;
    var prev = root.querySelector('[data-fm-rev-prev]');
    var next = root.querySelector('[data-fm-rev-next]');

    function page(dir) {
      // One viewport = exactly one row of cards, so this advances a full page.
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= max;
      var overflows = max > 0;
      if (prev) prev.disabled = atStart || !overflows;
      if (next) next.disabled = atEnd || !overflows;
      root.classList.toggle('is-static', !overflows);
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // Expanding a review changes card heights, not widths, but a re-check is cheap.
    track.addEventListener('toggle', sync, true);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-fm-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
